/**
 * The rule pages, grouped as the Rules side menu shows them. One list feeds
 * both the main sidebar's single "Rules" link (which opens the first of these
 * the user's role can see) and the side menu on every rule page
 * (`pages/settings/RulesLayoutPage.tsx`). Each page keeps its own URL and
 * role gate; this list only organises navigation. Tags and Item Type
 * Overrides are reference data (lists other things point at), not rules —
 * they live under Admin → Reference Data.
 */
export interface RulePage {
  href: string;
  /** Menu label — the "Rules" heading already says what kind of page it is. */
  label: string;
}

export interface RulePageGroup {
  label: string;
  pages: RulePage[];
}

export const RULE_PAGE_GROUPS: RulePageGroup[] = [
  {
    label: 'Orders & allocation',
    pages: [
      { href: '/settings/priority-rules', label: 'Allocation Priority' },
      { href: '/settings/allocation-strategy', label: 'Allocation Strategy' },
      { href: '/settings/channel', label: 'Channels' },
      { href: '/settings/so-routing', label: 'SO Routing' },
      { href: '/settings/order-holds', label: 'Order Holds' },
      { href: '/settings/auto-tag', label: 'Auto-Tag' },
      { href: '/settings/sku-replacement-rules', label: 'SKU Replacements' },
    ],
  },
  {
    label: 'Picking & bins',
    pages: [
      { href: '/settings/pick-path', label: 'Pick Path' },
      { href: '/settings/pick-split', label: 'Pick Split' },
      { href: '/settings/assignment', label: 'Assignment' },
      { href: '/settings/putaway', label: 'Putaway' },
      { href: '/settings/bin-reservation', label: 'Bin Reservation' },
      { href: '/settings/bin-priority', label: 'Bin Priority' },
    ],
  },
];

export const RULE_PAGES: RulePage[] = RULE_PAGE_GROUPS.flatMap((g) => g.pages);
